import EntityStats from "./EntityStats";
import Site from "./Site";

class Pilot {
  constructor(
    public id_user: number,
    public name: string,
    public description: string,
    public icon: number | undefined,
    public id_sites?: number[] | undefined,
    public id?: number | undefined,
    public GUID?: string | undefined,
    public created_on?: Date | undefined,
    public icon_path?: string | undefined,
    public sites?: Site[] | undefined,
    public counts?: EntityStats[] | undefined,
    public username?: string | undefined
  ) {}

  public static EmptyInstance(): Pilot {
    return new Pilot(-1, "", "", -1);
  }
}

export default Pilot;
